<div class="container">
    <div class="title">{{ "payment.cancel.title" | translate }}</div>
    <div class="subtitle">
        {{ "payment.cancel.subtitle" | translate }}
    </div>
    <div class="subtitle">
        {{ "payment.cancel.fallback" | translate }}
    </div>
    <div class="button" (click)="redirect()">
        {{ "payment.cancel.backButton" | translate }}
    </div>
</div>
